/*
 * Copyright (c) 2023 Bluemate B.V.
 */

export class DefaultNumberObject<K extends string | number | symbol = string> {
    private readonly defaultFunc: () => number;
    private readonly data: Record<K, number>;

    constructor(data?: Record<K, number>, defaultFunc?: () => number) {
        this.defaultFunc =
            defaultFunc ??
            function () {
                return 0;
            };
        this.data = data ?? ({} as Record<K, number>);
    }

    add = (key: K, value: number): DefaultNumberObject<K> => {
        if (!Object.hasOwn(this.data, key)) this.data[key] = this.defaultFunc();
        this.data[key] += value;
        return this;
    };

    get = (key: K): number => {
        if (Object.hasOwn(this.data, key)) return this.data[key];
        return this.defaultFunc();
    };

    has = (key: string): boolean => {
        return Object.hasOwn(this.data, key);
    };

    values = (): Array<number> => {
        return Object.values(this.data);
    };

    toRecord = (): Record<K, number> => {
        return this.data;
    };
}
